import { apiRequestActions } from '@ackee/redux-utils';
import { fetchSupportsTypes } from './types';

export default apiRequestActions(fetchSupportsTypes);
